import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        temIndex: 222,
    },
    actions: {
        editIndex(cxt, id) {
            cxt.commit('meditIndex', id)
        }
    },
    mutations: {
        meditIndex(state, id) {
            state.temIndex = id
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js